import React, {Component} from 'react'
import Dropdown from './Dropdown'

import style from './style.sass'

class Select extends Component {
  state = {
    dropdown: false
  }

  componentDidMount() {
    window.addEventListener('click', this.hideDropdown)
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.hideDropdown)
  }

  toggleDropdown = () => {
    const dropdown = !this.state.dropdown
    this.setState({dropdown})
  }
  hideDropdown = (e) => {
    if (this.wrapper.contains(e.target)) {
      return
    }
    this.setState({dropdown: false})
  }

  render() {
    const {dropdown} = this.state
    const {label, ...props} = this.props

    return(
      <div ref={el => this.wrapper = el} styleName='wrapper'>
        <button onClick={this.toggleDropdown} styleName={dropdown ? 'button-active' : 'button'}>
          {label}
        </button>
        <Dropdown
          visible={dropdown}
          {...props}
        />
      </div>
    )
  }
}

export default Select
